
import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';


 
  

  
export function rules_head(newState, state) {
    var newrule = includeRule(newState, state, 'head')
   
     
    
    newrule = excludeRule(newState, state, [
        ['ce', ['D','LD','UD']],
        ['ds', ['PR','M','E','RD']],
        ['head', ['T1TSP','T1TSR']]], newrule)
    
    
    newrule = excludeRule(newState, state, [
            ['ce', ['D','UD']],
            ['dctw', ['0.25','0.33','2','2.5','3','4','5','6','7','8','9','10']],
            ['head', ['T1TSP','T1TSR']]], newrule)
    newrule = excludeRule(newState, state, [
            ['ce', ['LD']],
            ['dctw', ['0.25','0.33','6','7','8','9','10']],
            ['head', ['T1TSP','T1TSR']]], newrule)    
        //-------------------------------------------------------------------------------------------------------------------------------
    
      
    newrule = excludeRule(newState, state, [
        ['ce', ['D','LD','UD']],
        ['ds', ['R','O','C']],
        ['head', ['T1TSP']]], newrule)
    
    newrule = excludeRule(newState, state, [
        ['ce', ['C']],
        ['head', ['T1TSP','T1TSR']]], newrule)
    
 
    newrule = excludeRule(newState, state, [
        ['ce', ['D','LD','UD']],
        ['ds', ['P']],
        ['head', ['T1TSR']]], newrule)
    

        
        
    //------------------------------------------------------------------------------------------------------------------
    
    newrule['show']  = true
      return newrule
}